/**
 * Where a guest session lives in the browser.
 *
 * These sit outside GuestContext so that AuthContext can read the guest token
 * without importing the provider that already depends on it — GuestProvider
 * derives its state from auth, so the keys living in either context would make
 * an import cycle between the two.
 */
export const GUEST_TOKEN_KEY = 'kundaliai_guest_token';
export const GUEST_ID_KEY = 'kundaliai_guest_id';
export const GUEST_NAME_KEY = 'kundaliai_guest_name';
export const GUEST_SEEN_KEY = 'kundaliai_guest_seen';
